const origin = {
  development: {
    osHost: "http://osweb-main.yishou.com",
  },
  test: {
    osHost: "http://osweb-main.yishou.com",
  },
  staging: {
    osHost: "https://osweb-prepublish.yishouapp.com",
  },
  production: {
    osHost: "https://osweb.yishouapp.com",
  },
};

export default {
  ...origin[process.env.NODE_ENV || "production"],
};



// WEBPACK FOOTER //
// ./src/const/config.js